import React, { useEffect } from 'react';
import { KFLLayout } from '@kamstrup/kamstrup-frontend-library';
import TopHeader from '../layout/topheader';
import Menu from '../layout/menu';
import Sidebar from '../layout/sidebar';
import OrdersContent from './content';
import * as Orders from '../../modules/orders';
import ActionsBar from './actionsBar';
import { Groups } from '../../models';

const OrdersPage: React.FC = () => {
  useEffect(() => Orders.updateColumns(), []);

  return (
    <KFLLayout
      topbar={<TopHeader />}
      content={<OrdersContent />}
      menu={
        <Menu title={Orders.msgTitle}>
          <ActionsBar />
        </Menu>
      }
      sidebar={<Sidebar selectedGroup={Groups.ORDERS} />}
    />
  );
};

export default OrdersPage;
